import { ChangeDetectionStrategy, Component } from '@angular/core'

/** Static "Backups suspended" notice for Account Settings; the host decides when to show it via `backupsSuspended`. */
@Component({
  selector: 'enforcement-mode-notice',
  templateUrl: './enforcement-mode-notice.component.html',
  styleUrls: ['./enforcement-mode-notice.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EnforcementModeNoticeComponent {}
